import "twin.macro";
import { useTranslation } from "react-i18next";
import Section, { SectionHashProps } from "../section";
import UnderConstruction from "../under_construction";

const FAQEnglish = ({ hash }: SectionHashProps) => {
  const { t } = useTranslation();
  return (
    <Section sub header={t("FAQ.English.Header")} hash={hash}>
      <dl tw="h-96">
        <UnderConstruction />
      </dl>
    </Section>
  );
};
export default FAQEnglish;
